module.exports = __webpack_public_path__ + "static/media/hrdlička5.95052fd9.jpg";